// extracted by mini-css-extract-plugin
export default {"root":"Cookies_root__C3Iw6","info":"Cookies_info__jDXAW","iconWrapper":"Cookies_iconWrapper__ETlPI","text":"Cookies_text__MS+35","button":"Cookies_button__awN51"};